<template>
<div class="row no-gutters body">
    <div class="col-lg-3 middle-background" v-if="viewsinglejob && currentRoute !== 'selectedloginviewjob'"></div>
    <div class="col-12 pb-5 mb-4" :class="{'col-lg-9':(viewsinglejob && currentRoute !== 'selectedloginviewjob'), 'col-lg-12':(viewsinglejob && currentRoute == 'selectedloginviewjob')}" v-if="pageloader">
        <img src="../assets/pageloader.svg" class="pageloader" :class="{'selectedloginviewjobstyles' : currentRoute == 'selectedloginviewjob'}" alt="loadinganimation">
        </div>
    <div class="col-12 pl-0 pr-0 main-card" :class="{'individualpage' :individualPage, 'col-lg-6':(viewsinglejob && currentRoute !== 'selectedloginviewjob'), 'col-lg-8 mx-auto':(viewsinglejob && currentRoute == 'selectedloginviewjob'), 'singlejobpage':viewsinglejob}" v-else>
        <div class=" card card1 ml-3 mr-3 mt-lg-2 jobSec" v-if="jobNotFound">
            <div class="d-flex flex-column p-5 mx-auto">
                <img src="../assets/JobNotFound1.png" class="img-fluid col-10 col-md-8 pl-0 pr-0 no-video mx-auto" alt="novideo">
            </div>
        </div>
        <div class="d-flex backgroundcolor2 borderadius12 p-1 pr-3 mb-2 pointer ml-1" style="width:140px" v-if="(individualPage || viewsinglejob) && currentRoute !== 'selectedloginviewjob' && !jobNotFound" @click="NavToJob">
            <img src="../assets/JobBack.svg" alt="back">
            <span class="fontsize14 stylebold black ml-1">Job Details</span>
        </div>
        <div class="shadow card borderradius10  pb-5 "  v-if="!jobNotFound">
                <div class="p-3 pt-4  pt-4 mb-1 d-flex">   
                    <div class="col-md-1 p-lg-2 pl-0 pr-0 borderradius10 mr-2 mt-1 text-center">
                        <img v-if="jobDetails.companydetails && jobDetails.companydetails.companyLogoLink" :src="jobDetails.companydetails.companyLogoLink" class="border loadingBgImg jobImg rounded-circle" alt="companylogo">
                        <img v-else src="../assets/Profile_placehlder.svg" class="jobImg rounded-circle" alt="companylogo">
                    </div>
                    <div class="col-10 pl-0 pl-md-2 pt-2">
                        <div class="d-flex justify-content-between">
                            <span class="fontsize24 black proximanova stylebold nameBlock">{{jobDetails.jobTitle}}</span> 
                            <div>
                                <img src="../assets/sharearrow.png" id="sharemenu" width="22px" height="22px" v-popover:sharemenu class="img-fluid closebtnmouseover mr-2 pointer more_optionhoriz" alt="moremenu">
                                <popover name="sharemenu" class="welcomemenu">
                                    <div class="p-2">
                                        <div class="d-flex p-1 justify-content-between">
                                            <span class="fontsize12 proximanova-bold black">More Actions</span>
                                            <div class="">
                                                <img src="../assets/Close1.svg" alt="close" class="img-fluid closebtnmouseover pointer" width="17px" height="17px" @click="closeMoreActions()">
                                            </div>
                                        </div>
                                        <!-- <div class="d-flex p-1 action pointer" id="onclickshare">
                                            <img src="../assets/Hide.svg" alt="hide" class="img-fluid pl-1 pr-1 ">
                                            <span class="pt-2 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Report Job</div>
                                            </span>
                                        </div>
                                        <div class="d-flex p-1 action pointer">
                                            <img src="../assets/Report.svg" alt="report" class="img-fluid pl-1 pr-1">
                                            <span class="pt-2 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Hide Job</div>
                                            </span>
                                        </div> -->
                                        <div class="d-flex p-1 action pointer"  @click="shareJob(jobDetails)">
                                            <img src="../assets/sharejob.png" alt="report" width="28" height="20" class="my-auto pl-1 pr-1">
                                            <span class="pt-1 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Share</div>
                                            </span>
                                        </div>
                                        <div class="d-flex p-1 action pointer"  @click="copyJobLink(jobDetails)">
                                            <img src="../assets/hyperlink1.png" alt="report" width="28" height="20" class="my-auto pl-1 pr-1">
                                            <span class="pt-1 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Copy link</div>
                                            </span>
                                        </div>
                                    </div>
                                </popover>
                            </div>                        
                        </div>
                        <div class="d-flex flex-column mt-2">
                            <span class="fontsize16 black proximanova" v-if="jobDetails.companydetails">{{jobDetails.companydetails.companyName}}</span>
                            <span class="fontsize16 black proximanova" v-else>Worknotion</span>
                            <div>
                                <span class="fontsize16 black60 proximanova" v-if="jobDetails.companydetails">{{jobDetails.companydetails.industry}}</span>
                                <span class="fontsize16 black60 proximanova" v-else> - </span>
                                <span class="ml-2 mr-2 black60">|</span>
                                <span class="fontsize16 black60 proximanova">{{jobDetails.country.countryName}}</span>
                            </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                            <div class="mt-1">
                                <span class="fontsizemd black stylebold proximanova" v-if="jobDetails.creationD">{{jobDetails.creationD | moment("from", "now", true)}} ago</span>
                                <span class="ml-2 mr-2 black60">|</span>
                                <span class="forgot-password proximanova">{{jobDetails.totalnumberofapplicants}} Candidates Applied</span>
                            </div>                            
                        </div>
                        <div class="d-flex   justify-content-between">
                            <div class="d-flex flex-column  mb-2 pt-2 justify-content-between">
                                <!-- <div class="row mt-2 ml-0 d-flex "  >
                                    <div  v-for="(item1,index1) in followersProfilePictures" :key="index1" class="d-flex">
                                        <div  class="">                                                        
                                            <img :src="item1" class="img-fluid rounded-circle" alt="follwers" id="followImage">                                                                        
                                        </div>                                          
                                    </div> 
                                    <span class="proximanova fontsize10 black60 ml-1 mt-2 d-none d-md-block d-lg-block">5+ followers works here</span>                                                           
                                </div>  -->
                            </div>
                            <div class="pt-2 d-flex justify-content-end my-auto">
                                <!-- <div class="my-auto">
                                    <button class="btn button-cancel11 mr-2 navtoPage proximanova mouseoverbtn1">Save</button>
                                </div> -->
                                <div class="my-auto mr-2" v-if="jobDetails.jobActive == 'ACTIVE'">
                                <button v-if="jobDetails.appliedStatus !== 'Y'" class="btn backgroundcolor3 borderradius20 white fontsizemd proximanova mouseoverbtn2" :disabled="applyBtnClicked" @click="ApplyJob">Apply</button>
                                <span v-else class="fontsize14 green proximanova">Applied</span>
                                </div>
                                <div class="my-auto mr-2" v-else>
                                <span class="fontsize14 red proximanova">Closed</span>
                                </div>
                            </div>
                                                
                        </div>
                    </div>
                </div>
                <hr class="profhoriz">
                <div class="col-12 p-3 ml-md-3 mr-md-3">
                    <div class="d-flex mb-2">
                        <div class="pl-lg-2 pr-1">
                            <img src="../assets/JobViewHired.svg" class="iconImg" alt="hired">
                        </div>
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Employment Type</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">
                            <span class="fontsizemd black proximanova" v-if="jobDetails.employeeType">{{jobDetails.employeeType.indexDetailName}}</span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="pl-lg-2 pr-1">
                            <img src="../assets/JobViewSeniority.svg" class="iconImg" alt="seniority">
                        </div>
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Seniority</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">
                            <span class="fontsizemd black proximanova" v-if="jobDetails.seniorityType">{{jobDetails.seniorityType.indexDetailName}}</span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="pl-lg-2 pr-1">
                            <img src="../assets/JobViewAmount.svg" class="iconImg" alt="salary">
                        </div>
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Pay Scale</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">
                            <span class="fontsizemd black proximanova">{{jobDetails.payScaleFrom}} - {{jobDetails.payScaleTo}}</span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="pl-lg-2 pr-1">
                            <img src="../assets/JobViewLocation.svg" class="iconImg" alt="location">
                        </div>
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Job Location</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">
                            <span class="fontsizemd black proximanova">{{jobDetails.city.cityName}}, {{jobDetails.country.countryName}}, {{jobDetails.zipcode}}.</span>
                        </div>
                    </div>
                    
                </div>
                <hr class="profhoriz">
                <div class="col-12">
                    <div class="d-flex flex-column pl-md-3 pr-md-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Job Description</span>
                        <!-- <span class="fontsizemd proximanova black mb-3 lineheight22">{{jobDetails.jobDesc}}</span> -->
                        <quill-editor v-model="jobDetails.jobDesc" :options="editorOption" class="quill1" disabled></quill-editor>
                    </div>
                    <div class="horizontalline mt-1 mb-2" v-if="jobDetails.addedSkillsList.length > 0"></div>
                </div>
                <div class="col-12" v-if="jobDetails.addedSkillsList.length > 0">
                    <div class="d-flex flex-column pl-md-3 pr-md-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Skills Required</span>
                        <div class="row no-gutters mt-2 ml-0">
                            <div v-if="jobDetails.addedSkillsList && jobDetails.addedSkillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(skill, index) in jobDetails.addedSkillsList" :key="index" >
                                    <div class="pl-3 pr-3 p-1 mr-3 text-nowrap black80 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                        {{skill.skillName}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="horizontalline mt-3 mb-3" v-if="jobDetails.screeningQuestionsList.length > 0"></div> -->
                </div>
                <!-- <div class="col-12 pb-3" v-if="jobDetails.screeningQuestionsList.length > 0">
                    <div class="d-flex flex-column pl-md-3 pr-md-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">More Details</span>
                        <span class="fontsizemd proximanova black mb-3 lineheight22">Screening Questions.</span>
                        <div v-for="(question, index) in jobDetails.screeningQuestionsList" :key="index" class="d-flex flex-column">
                            <span class="fontsizemd proximanova black60 mb-1 lineheight22">{{index+1}} . {{question.question}}</span>
                        </div>
                    </div>
                </div> -->
                <div class="horizontalline mt-1 mb-2"  v-if="jobDetails.companydetails"></div>         
                <div class="col-12" v-if="jobDetails.companydetails">
                    <div class="d-flex flex-column pl-2 pr-2 pt-2 pb-3">
                        <span class="fontsize16 stylebold proximanova black mb-2">About the Company</span>
                        <div class="d-flex mt-2">
                            <div class="">
                                <img v-if="jobDetails.companydetails && jobDetails.companydetails.companyLogoLink" :src="jobDetails.companydetails.companyLogoLink" alt="companylogo" oncontextmenu="return false" class="profile-border img-fluid rounded-circle loadingBgImg jobImg" id="profImage">
                                <img v-else src="../assets/Profile_placehlder.svg" oncontextmenu="return false" alt="companylogo" class="profile-border img-fluid rounded-circle jobImg" id="profImage">
                            </div>
                            <div class="d-flex flex-column col-10 pr-0">
                                <div class="d-flex justify-content-between">
                                    <span class="font32 proximanova nameBlock">{{jobDetails.companydetails.companyName}}</span>
                                    <button @click="followCompany" :disabled="disablefollowBtn" v-if="followingTest === 'Follow'" class="btn button-cancel11 proximanova-semibold borderradius20 my-auto followbtn mr-2 navtoPage" style="height:35px">{{followingTest}}</button>
                                    <button @click="unfollowCompany" :disabled="disablefollowBtn" v-if="followingTest === 'UnFollow'" class="btn button-cancel11 proximanova-semibold borderradius20 my-auto followbtn mr-2 navtoPage" style="height:35px">{{followingTest}}</button>
                                </div>
                                <div class="d-flex">
                                    <span class="fontsize16 black60 proximanova" v-if="jobDetails.companydetails.industry">{{jobDetails.companydetails.industry}}</span>
                                    <span v-else> - </span>
                                    <span class="ml-2 mr-2 black60">|</span>
                                    <span class="fontsize16 black60 proximanova" v-if="jobDetails.companydetails.country">{{jobDetails.country.countryName}}</span>
                                    <span v-else> - </span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="col-lg-1 col-md-1 col-0 p-0"></div>
                            <div class="col-lg-10 col-md-11 col-12 ">
                                <span class="fontsizemd proximanova black p-0">{{jobDetails.companydetails.description}}</span>
                            </div>
                        </div>
                        <div class="d-flex mt-3 ml-1 pr-1"  v-if="jobDetails.companydetails">
                            <div class="col-lg-1 col-md-1 col-0 p-0"></div>
                            <div class="col-lg-10 col-md-11 col-12 ">
                            <a class="fontsize14 blue proximanova my-auto" v-if="jobDetails.companydetails && jobDetails.companydetails.twitterURL" :href="jobDetails.companydetails.twitterURL" target="_blank">
                                <img src="../assets/twitter.svg" class="" width="25px" alt="twitter">
                            </a>
                            <a class="fontsize14 blue proximanova my-auto" v-if="jobDetails.companydetails && jobDetails.companydetails.linkedInURL" target="_blank" :href="jobDetails.companydetails.linkedInURL">
                                <img src="../assets/linkedin.svg" class="ml-3" width="23px" alt="linkedin">
                            </a>
                            <a class="fontsize14 blue proximanova my-auto" v-if="jobDetails.companydetails && jobDetails.companydetails.youtubeURL" target="_blank" :href="jobDetails.companydetails.youtubeURL">
                                <img src="../assets/youtube.svg" class="ml-3" width="27px" alt="youtube">
                            </a>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="col-lg-1 col-md-1 col-0 p-0"></div>
                            <div class="col-12 col-md-11">
                                <div class="row ">     
                                    <div class="mt-2 count">       
                                        <div class="row m-0">       
                                            <div class="col-3 mr-3">
                                                <label class="font14bold proximanova-semibold">Followers</label>
                                                <label class="font14bold proximanova-semibold">{{followersCount}}</label>
                                            </div>
                                            <div class="col-3 ml-3">
                                                <label class="font14bold proximanova-semibold">Following</label>
                                                <label class="font14bold proximanova-semibold">{{followingCount}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                <div v-if="jobDetails.companyIntroVideoDetails">
                    <div class="videocardbody">
                    <div class="col-12   productvideocard">                         
                      <div >                         
                        <video height="320" oncontextmenu="return false" @ended="onenddisplayreplayIcon()" @waiting="displayLoadingLogo()" @canplay="stopLoadingLogo()" controlsList="nodownload"  id="companyIntroVideo" >
                          <source :src="jobDetails.companyIntroVideoDetails.videoLink" id="introvideosrctag">
                        </video>
                      </div>  
                      <div class="card-img-overlay p-0"> 
                        <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1">
                          <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                        </div>
                        <div class="mt-3 mx-auto">
                          <img src="../assets/play_video.svg" v-if="playIntroVideo" class="playpausevideobtn" alt="playvideo" @click="playPauseCompanyVideo()">
                          <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="!playIntroVideo && replayIntroVideo">
                                <img src="../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo()">
                            </div>
                            <div class="replaybtn1 shadow playpausevideobtn" title="replay video" id="playvideobtn" v-if="!playIntroVideo && loadingIntroVideo">
                                <img src="../assets/video_loading.gif" class="replayicon1 mx-auto" alt="videoloading">
                            </div>
                          <img src="../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="!playIntroVideo && !replayIntroVideo && !loadingIntroVideo" alt="pausevideo" @click="playPauseCompanyVideo()">
                        </div>
                        <div class="bottom">
                          <div class="companyvid_overlay2">
                            <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    <!-- <video height="320" oncontextmenu="return false" :src="jobDetails.companyIntroVideoDetails.videoLink" controlsList="nodownload"  id="introVideo" > </video> -->
                </div>  
                <div class="col-12 mb-4" v-if="jobDetails.companydetails">
                    <label class="fontsize14 black stylebold proximanova ml-3">More Details</label>
                    <div class="d-flex mb-2" v-if="jobDetails.companydetails.contactNumber">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Contact Number</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">                          
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.contactNumber">
                                {{jobDetails.companydetails.contactNumber}}
                            </span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2" v-if="jobDetails.companydetails.companySize">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Company Size</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">                          
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.companySize">
                                {{jobDetails.companydetails.companySize}}
                            </span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2" v-if="jobDetails.companydetails.industry">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Industry</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">                          
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.industry">
                                {{jobDetails.companydetails.industry}}
                            </span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2" v-if="jobDetails.companydetails.founded">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Founded</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">                          
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.founded">{{jobDetails.companydetails.founded}}</span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2" v-if="jobDetails.companydetails.specialities">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Specialities</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">                          
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.specialities">
                                {{jobDetails.companydetails.specialities}}
                            </span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2" v-if="jobDetails.companydetails.type">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Type</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7">                          
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.type">
                                {{jobDetails.companydetails.type}}
                            </span>
                            <span v-else> - </span>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="col-lg-4 col-md-4 col-5">
                            <span class="fontsizemd black60 proximanova">Location</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-7 d-flex">                         
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.city">{{jobDetails.companydetails.city.cityName}}, </span>
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.state">{{jobDetails.companydetails.state.stateName}}, </span>
                            <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.country">{{jobDetails.companydetails.country.countryName}}</span>
                        </div>
                    </div>
                    <!-- <div class="horizontalline mb-2 mt-3"></div>
                    <div class="d-flex">
                        <div class="mt-1 mb-1 ml-3 mr-auto">
                            <label class="fontsize14 black60 stylebold proximanova">Social Media</label>
                        </div>
                    </div>
                    <div class="mb-3" v-if="jobDetails.companydetails">
                        <div class="col-12 d-flex pl-0">
                        <span class="fontsize14 black60 proximanova col-lg-4 col-6">Twitter URL</span>
                        <a class="fontsize14 blue proximanova" v-if="jobDetails.companydetails.twitterURL" :href="jobDetails.companydetails.twitterURL" target="_blank">
                            <img src="../assets/twitter.svg" class="img-fluid" alt="twitter">
                        </a>
                        <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                    </div>
                    <div class="row ml-0 mb-3" v-if="jobDetails.companydetails">
                        <div class="col-12 d-flex pl-0">
                        <span class="fontsize14 black60 proximanova col-lg-4 col-6">Linked in URL</span>
                        <a class="fontsize14 blue proximanova" v-if="jobDetails.companydetails.linkedInURL" target="_blank" :href="jobDetails.companydetails.linkedInURL">
                            <img src="../assets/linkedin.svg" class="img-fluid" alt="linkedin">
                        </a>
                        <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                    </div>
                    <div class="row ml-0 mb-3" v-if="jobDetails.companydetails">
                        <div class="col-12 d-flex pl-0">
                        <span class="fontsize14 black60 proximanova col-lg-4 col-6">Youtube URL</span>
                        <a class="fontsize14 blue proximanova" v-if="jobDetails.companydetails.youtubeURL" target="_blank" :href="jobDetails.companydetails.youtubeURL">
                            <img src="../assets/youtube.svg" class="img-fluid" alt="youtube">
                        </a>
                        <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                    </div> -->
                </div>   
            </div>
        </div>
        <div class="col middle-background" v-if="viewsinglejob && !pageloader && currentRoute !== 'selectedloginviewjob'">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class="row row no-gutters">
                        <br />
                    </div>
                    <pendingActivities />
                </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
        <MeetYourProfileStrengthModal v-if="openMeetYourProfileStrengthModal" @closeMeetYourProfileStrengthModal="closeMeetYourProfileStrengthModal"></MeetYourProfileStrengthModal>
</div>
</template>
<script>
import { bus } from "../main";
import httpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js";
import APIerrorModal from './APIerrorpopup.vue'
import pendingActivities from "./PendingActivities.vue";
import router from '../router.js'
import wndata from '@/js/wn_data.json'
import commonUtils from '@/js/common-utils.js'
import sessionUtils from '@/js/session-util.js'
import MeetYourProfileStrengthModal from './MeetYourProfileStrength.vue'
export default{
    components: {
        APIerrorModal,
        pendingActivities,
        MeetYourProfileStrengthModal
    },
    data(){
        return{
            documentTitle : 'Worknotion | Collaboration Network and Job search',
            jobNotFound : false,
            currentRoute : null,
            pageloader : true,
            viewsinglejob : false,
            individualPage : false,
            currentUserProfileId : null,
            jobId : null,
            selectedJobAliasID : '',
            applyStatus : false,
            jobDetails : null,
            followersCount : 0,
            followingCount : 0,
            followingTest : 'Follow',
            disablefollowBtn : false,
            applyBtnClicked : false,
            savedIntroVideoLink : null,
            playIntroVideo : true,
            replayIntroVideo : false,
            loadingIntroVideo : false,
            editorOption: {
                theme: 'bubble'
            },
            openMeetYourProfileStrengthModal : false,
            displayAPIerrorModal : false,
            addedSkillsList : ['java', 'html', 'css', 'javascript'],
            followersProfilePictures: [require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg')],
        }
    },
    watch: {
        '$route.params.id': function () {     
            this.individualPage = false
            this.viewsinglejob = true
            this.jobNotFound = false
            this.documentTitle = ''
            this.jobDetails = null
            this.followingTest = 'Follow'
            this.selectedJobAliasID = this.$route.params.id
            this.getJobDetailsByAliasId() 
        }
    },
    mounted(){
        window.scrollTo(0, 0)
        let currentRoute = this.$route.name;
        this.currentRoute = currentRoute;
        console.log("route name : ", currentRoute)
        this.currentUserProfileId = sessionUtils.getUserProfileId();
        this.jobId = this.$session.get("selectedJobId");
        this.applyStatus = this.$session.get("selectedJobApplyStatus")
        this.updateMetaInfo()
        if(currentRoute === 'viewjob'){
            this.individualPage = false
            this.viewsinglejob = true
            this.selectedJobAliasID = this.$route.params.id
            this.getJobDetailsByAliasId()
        }
        if(currentRoute === 'selectedloginviewjob'){
            this.individualPage = false
            this.viewsinglejob = true
            this.selectedJobAliasID = this.$route.params.id
            this.getJobDetailsByAliasIdbeforelogin()
        }
        if(currentRoute === 'job_details'){
            this.individualPage = true
            this.viewsinglejob = false
            this.getJobDetails()
        }
        if(!this.individualPage && currentRoute !== 'viewjob') {
            bus.$on("jobSelection", data => {
                console.log("data in videoviews : ", data)
                this.jobId = data.jobId;
                this.applyStatus = data.applyStatus;
                this.getJobDetails()
            })
        }
    },
    beforeDestroy(){
        bus.$off('jobSelection')
        if(this.currentRoute != 'selectedloginviewjob'){
        this.$session.remove("selectedJobAliasId")
        }
        document.title = "Worknotion | Collaboration Network and Job search"
        document.description = "Worknotion is a professional networking platform that allows users to build community, grow their network, get freelance projects, search and apply for jobs online for free."
    },
    methods:{
        updateMetaInfo() {
            document.title = this.documentTitle
        },
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        closeMeetYourProfileStrengthModal() {
            this.openMeetYourProfileStrengthModal = false;
        },
        NavToJob() {
            // this.$router.go(-1);
            router.push({
                name : 'job'
            })
        },
        //this will invoke after click on close button on more actions menu
        closeMoreActions : function(){
        document.getElementById('sharemenu').click()
        },
        shareJob : function(jobObj){
            commonUtils.shareJob(jobObj)
        },
        copyJobLink(jobObj) {
            commonUtils.copyJobLink(jobObj)
        },
        getJobDetailsByAliasId() {
            this.pageloader = true;
            this.applyBtnClicked = false;
            httpjob.get('/postjob/getJobDetailsByJobAliasName?jobAliasId='+this.selectedJobAliasID+'&userProfileId='+this.currentUserProfileId)
            .then((response) => {
                this.pageloader = false;
                console.log("with aliasId : ", response)
                this.jobDetails = response.data;
                if(response.data && response.data.errorCode && response.data.errorCode == 1021){
                    this.jobNotFound = true;
                }else{
                    this.jobNotFound = false;
                }
                if(this.jobDetails && !this.jobNotFound){
                    this.jobId = this.jobDetails.jobId;
                    this.$session.set("selectedJobId" , this.jobId)
                    this.documentTitle = this.jobDetails.companydetails.companyName+' Hiring '+this.jobDetails.jobTitle+' in '+this.jobDetails.city.cityName+', '+this.jobDetails.state.stateName+'|Worknotion'
                    this.updateMetaInfo()
                    this.fetchFollowFlag()
                    this.fetchCompanyFollowCounts()
                }
                this.jobDetails
            }).catch((e) => {
                console.log(e.response)
                this.pageloader = false;
            })
        },
        getJobDetailsByAliasIdbeforelogin(){
            this.pageloader = true;
            this.applyBtnClicked = false;
            httpjob.get('/postjob/getJobDetailsByJobAliasName?jobAliasId='+this.selectedJobAliasID+'&userProfileId=0')
            .then((response) => {
                this.pageloader = false;
                console.log("with aliasId : ", response)
                this.jobDetails = response.data;
                if(response.data && response.data.errorCode && response.data.errorCode == 1021){
                    this.jobNotFound = true;
                }else{
                    this.jobNotFound = false;
                }
                if(this.jobDetails && !this.jobNotFound){
                    this.jobId = this.jobDetails.jobId;
                    this.$session.set("selectedJobId" , this.jobId)
                    this.documentTitle = this.jobDetails.companydetails.companyName+' Hiring '+this.jobDetails.jobTitle+' in '+this.jobDetails.city.cityName+', '+this.jobDetails.state.stateName+'|Worknotion'
                    this.updateMetaInfo()
                    if(this.currentRoute !== 'selectedloginviewjob'){
                    this.fetchFollowFlag()
                    }
                    this.fetchCompanyFollowCounts()
                }
            }).catch((e) => {
                console.log(e.response)
                this.pageloader = false;
            })
        },
        //this will invoke after component is mounted to get the job details based on job id
        getJobDetails(){
            this.pageloader = true;
            this.applyBtnClicked = false;
            httpuserprofile.get('/userprofile/getjobDetailsById?jobId='+this.jobId+'&userprofileid='+this.currentUserProfileId)
            .then((response) => {
                this.pageloader = false;
                console.log(response)
                this.jobDetails = response.data;
                if(this.jobDetails){
                    this.fetchFollowFlag()
                    this.fetchCompanyFollowCounts()
                }
            }).catch((e) => {
                console.log(e.response)
                this.pageloader = false;
            })
        },
        // fetching the follow relation between loggedin user and the company
        fetchFollowFlag(){
            httpuserprofile.get("/userprofile/getUsertoCompanyFollowFlag?profileId="+this.currentUserProfileId+'&companyProfileId='+this.jobDetails.companyProfileId)
            .then((response) => {
                console.log("company follow flag : ", response)
                let followflag = response.data[0].followingFlag;
                if(followflag == 'Y'){
                this.followingTest =  'UnFollow'; 
                }else if(followflag == 'N'){
                this.followingTest =  'Follow'; 
                }
            })
        },
        //fetching the counts of posted videos, followers and following users count for the selected company
        fetchCompanyFollowCounts(){
            httpuserprofile.get("/userprofile/getCompanyFollowAndFollowingCount?companyProfileId="+this.jobDetails.companyProfileId)
            .then((response) => {
                console.log("counts of the company : ", response);
                this.followersCount = response.data.followerCount;
                this.followingCount = response.data.followingCount;
            })
        },
        //follow company
        followCompany() {
            if(this.currentRoute !== 'selectedloginviewjob'){
            this.disablefollowBtn = true;
            httpuserprofile.post("/userprofile/saveUserToCompanyFollowing?UserProfileId="+this.currentUserProfileId+"&CompanyProfileId="+this.jobDetails.companyProfileId)
            .then(response => {
                console.log("user to company follow : ", response)
                // after successfully saved get followers list of the company to update the data  
                this.followingTest =  'UnFollow'; 
                this.followingCount = this.followingCount + 1;
                this.disablefollowBtn = false;
            }).catch((e) => {
                console.log(e)
                this.disablefollowBtn = false;
                this.displayAPIerrorModal = true;
            }); 
            }else{
                this.$session.set("selectedJodDetailsFromLogin", true)
                router.push({
                    name : 'signin'
                })
            }
        },
        //unfollow company
        unfollowCompany() {
            if(this.currentRoute !== 'selectedloginviewjob'){
            this.disablefollowBtn = true;
            httpuserprofile.delete("/userprofile/UserToCompanyunfollow?UserProfileId="+this.currentUserProfileId+"&CompanyProfileId="+this.jobDetails.companyProfileId)
            .then(response => {
                console.log("user to company unfollow : ", response)
                // after successfully saved get followers list of the company to update the data  
                this.followingTest =  'Follow'; 
                this.followingCount = this.followingCount - 1;
                this.disablefollowBtn = false;
            }).catch((e) => {
                console.log(e)
                this.disablefollowBtn = false;
                this.displayAPIerrorModal = true;
            });
            }else{
                this.$session.set("selectedJodDetailsFromLogin", true)
                router.push({
                    name : 'signin'
                })
            }
        },
        // this will invoke aftre click on play/pause icons on company intro video
        playPauseCompanyVideo() {
            this.playIntroVideo = !this.playIntroVideo;
            var video = document.getElementById("companyIntroVideo")
            if(this.playIntroVideo){
                video.pause()
            }else{
                video.play()
            }
        },
        onenddisplayreplayIcon() {
            this.replayIntroVideo = true;
            this.loadingIntroVideo = false;
        },
        displayLoadingLogo() {
            this.loadingIntroVideo = true;
        },
        stopLoadingLogo() {
            this.loadingIntroVideo = false;
        },
        replayVideo() {
            this.replayIntroVideo = false;
            this.loadingIntroVideo = false;
            this.playIntroVideo = false;
            this.playPauseCompanyVideo()
        },
        // this will invoke after click on apply job button
        ApplyJob() {
            if(this.currentRoute !== 'selectedloginviewjob'){
                let canbeApply = commonUtils.checkJobLevelToApply(this.jobDetails.seniorityType.indexDetailName)
                if(canbeApply){
            var vm = this;
            this.$session.set("selectedJobId", this.jobDetails.jobId);
            if(this.jobDetails.screeningQuestionsList.length > 0){
                this.MoveToRecordScreeningQuestions()
            }else{
            this.applyBtnClicked = true;
            let obj = {
                jobId: this.jobDetails.jobId,
                userProfileId: this.currentUserProfileId,
                jobStatus: "POST",
                creationD: null,
                creationUserI: sessionUtils.getUserEmail(),
                updateD: null,
                updatedUserI:null  
            }
            console.log(obj)
            httpuserprofile.post('/userprofile/ApplyToJob', obj)
            .then(response => {    
                console.log("apply for a job : ", response)
                // this.$session.set("selectedJobId", jobItem.jobId);
                this.applyBtnClicked = false;
                if(response.data.errorCode !== 1047) {
                    this.applyStatus = true;
                    this.jobDetails.appliedStatus = 'Y';
                    vm.$toast.success("Applied successfully")
                    // if(this.jobDetails.screeningQuestionsList.length > 0){
                    //     this.MoveToRecordScreeningQuestions()
                    // }
                }
            }).catch(error=>{   
                this.applyBtnClicked = false;
                console.log(error);  
                this.displayAPIerrorModal = true;
            }) 
            }
            }else{
                this.openMeetYourProfileStrengthModal = true;
            }
            }else{
                this.$session.set("selectedJodDetailsFromLogin", true)
                router.push({
                    name : 'signin'
                })
            }
            // this has  to be called once get successfully applied for the job
            // this.MoveToRecordScreeningQuestions()
        },
        MoveToRecordScreeningQuestions(){
            router.push({
                name : 'recordScreeningQuestions'
            })
        },
    }
}
</script>
<style scoped>
.productvideocard{
	padding-left: 0;
	padding-right: 0;
	border-radius: 10px;
  }
.pausebtn{
  display: none;
}
.productvideocard:hover .pausebtn{
  display: block;
  margin-top: 7.5% !important;
}
.jobSec {
  /* background-color: #e8e9eb; */
  background-color: rgba(161, 166, 179, 0.085);
  border: none;
}
.playpausevideobtn{
    margin-top: 5% !important;
    margin-left: 48% !important;
    cursor: pointer;
  }
  video{
      width: 100%;
  }
  .bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.activeBtn{
    background-color: rgba(16,163,129,0.2);
}
.backgroundcolor2 {
    /* width: 80px; */
    padding-left: 20px !important;
}
.quill1{
  width: 100%;
}
.iconImg{
    width: 20px;
    height: 20px;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.individualpage{
    background: #F0F2F5 !important;
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
.white{
    color: white !important;
}
.pageloader {
  width: 10%;
  margin-top: 15%;
  margin-bottom: 5%;
  margin-left: 46%;
}
.selectedloginviewjobstyles{
    width: 5%  !important;
    margin-left: 48%;
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  background: none !important;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.individualpage{
    margin-top: 15%;
    margin-bottom: 15%;
    padding-left: 5% !important;
    padding-right: 5% !important;
}
.singlejobpage{
    margin-top: 7%;
    margin-bottom: 5%;
    padding-left: 2% !important;
    padding-right: 2% !important;
}
.profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1)
}
#introVideo{
    width: 100%;
}
.jobImg{
    width: 50px;
    height: 50px;
}
.followbtn{
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  text-align: right;
  /* right:2%; */
  padding-left : 5px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
}
.followbtn::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 10%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius:20px;
  background-color :  rgba(31,31,31,.3);
}
.followbtn:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  border-radius:20px;
}
#playvideobtn {
  /* display: none; */
  margin-left: 45%;
  margin-top: 7% !important;
  cursor: pointer;
}
.action:hover{
    background: rgba(31,31,31,.1);
    border-radius: 5px;
}
.closebtnmouseover {
    border: 1px solid white;
    padding: 2px;
}
.closebtnmouseover:hover {

  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.welcomemenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.welcomemenu.dropdown-position-bottom {
  left: unset !important;
  /* right: 0 !important; */
  top: 20px !important;
  width: 220px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-82%, 10px, 10px) !important;
}
@media only screen and (max-width: 550px) {
    .individualpage{
        margin-top: 22%;
        margin-bottom: 15%;
    }
    .singlejobpage{
        margin-top: 22% !important;
        margin-bottom: 15%;
    }
    #followImage{
  width: 20px;
  height: 20px;
    }
    .jobImg{
    width: 40px;
    height: 40px;
}
    .nameBlock{
        font-size: 18px !important;
	}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (max-width : 768px) {
  .pageloader {
      width: 10%;
    margin-top: 25% !important;
  }
  .singlejobpage{
        margin-top: 15%;
        margin-bottom: 15%;
    }
}
</style>